import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import '../menu-item/menu-item.scss';
import './sub-menu.scss';

const directions = {
    UP: 'up',
    DOWN: 'down'
};

const mouseLeaveTimeoutLength = 500;

class SubMenu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isSubMenuOpen: false,
            direction: directions.DOWN
        };
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
        if (this.mouseLeaveTimeout) {
            clearTimeout(this.mouseLeaveTimeout);
        }
    }

    handleClick = () => {
        this.handleSubMenuOpen();
    };

    handleMouseEnter = () => {
        if (!this.state.isSubMenuOpen) {
            this.handleSubMenuOpen(true);
        }
        if (this.mouseLeaveTimeout) {
            clearTimeout(this.mouseLeaveTimeout);
        }
    };

    handleMouseLeave = () => {
        if (this.state.isSubMenuOpen) {
            this.mouseLeaveTimeout = setTimeout(() => {
                this.setState({ isSubMenuOpen: false });
            }, mouseLeaveTimeoutLength);
        }
    };

    handleSubMenuOpen = () => {
        if (!this.props.isDisabled) {
            const submenuClientRect = this.subMenu.getBoundingClientRect();
            const isBelowScreenHalf = (window.innerHeight / 2) - submenuClientRect.y < 0;
            this.setState({
                isSubMenuOpen: true,
                direction: isBelowScreenHalf ? directions.UP : directions.DOWN
            });
            document.addEventListener('click', this.handleDocumentClick);
        }
    };

    handleDocumentClick = () => {
        this.setState({ isSubMenuOpen: false });
        document.removeEventListener('click', this.handleDocumentClick);
    };

    getMenuItemsClass() {
        let menuItemsClass = 'sten-menu__items sten-menu__items--visible';
        if (this.state.direction === directions.DOWN) {
            menuItemsClass += ' sten-menu__items--collapse-down';
        }
        if (!this.props.children.some((child) => child && child.props.icon)) {
            menuItemsClass += ' sten-menu--no-icons';
        }

        return menuItemsClass;
    }

    saveRef = (c) => { this.subMenu = c; };

    render() {
        let className = 'sten-menu-item sten-sub-menu flex flex-center';

        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        if (this.state.isSubMenuOpen) {
            className += ' sten-menu-item--active';
        }
        if (this.props.isDisabled) {
            className += ' sten-menu-item--disabled';
        } else {
            className += ' sten-menu-item--clickable';
        }

        return (
            <div
                ref={this.saveRef}
                className={className}
                onClick={this.handleClick}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <div className="sten-menu-item__icon">
                    {this.props.icon && <span className={`icon ${this.props.icon}`} />}
                </div>
                <span className="sten-menu-item__text">{this.props.text}</span>

                {this.state.isSubMenuOpen && (
                    <div className={this.getMenuItemsClass()}>
                        {this.props.children}
                    </div>
                )}
                <span className="sten-sub-menu__chevron icon icon-chevron-right" />
            </div>
        );
    }
}

SubMenu.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    icon: PropTypes.string,
    isDisabled: PropTypes.bool,
    text: PropTypes.string.isRequired
};

SubMenu.defaultProps = {
    className: '',
    icon: '',
    isDisabled: false
};

export default SubMenu;
